import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const RotateLeftIcon = ({ color = '#fff', size = 20, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 77 77"
    width={size}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.905 15.565c5.07-3.702 11.37-5.788 18.123-5.546 16.006.572 28.517 14.013 27.943 30.02C66.4 56.044 52.958 68.554 36.95 67.98c-12.288-.44-22.527-8.47-26.352-19.43-.546-1.563-2.146-2.57-3.76-2.19l-3.892.917c-1.613.38-2.623 2-2.12 3.578 4.862 15.234 18.86 26.512 35.767 27.117 21.526.772 39.6-16.053 40.372-37.578.77-21.525-16.054-39.6-37.58-40.372-9.654-.345-18.612 2.85-25.624 8.415L8.402 3.096C6.662 1.36 3.687 2.34 3.318 4.77L.035 26.335c-.305 2.003 1.423 3.726 3.425 3.416l21.56-3.34c2.427-.378 3.398-3.355 1.658-5.09l-5.773-5.757z"
      fill={color}
    />
  </svg>
);

RotateLeftIcon.propTypes = propTypes;

export default RotateLeftIcon;
